import { useContext } from 'react';
import { SectionContext } from '../context/SectionContext';
import ErrorSectionFormatter from './formatters/ErrorSectionFormatter';
import { defaultSectionRegistry } from './formatters/registry';
import { jsx as _jsx } from "react/jsx-runtime";
const AISectionV2 = ({
  callbacks,
  message,
  section,
  disableActions,
  disableArtifacts,
  actionsTooltip,
  isStreaming,
  showLoadingDotWhenStreaming,
  registry = defaultSectionRegistry,
  isInCanvasView,
  trellisComponents
}) => {
  const {
    getIsUngated
  } = useContext(SectionContext);
  const renderer = registry[section.__typename];
  if (!renderer) {
    return /*#__PURE__*/_jsx(ErrorSectionFormatter, {
      section: section
    });
  }
  return renderer({
    callbacks,
    message,
    section,
    disableActions,
    disableArtifacts,
    actionsTooltip,
    isStreaming,
    showLoadingDotWhenStreaming,
    getIsUngated,
    registry,
    isInCanvasView,
    trellisComponents
  });
};
export default AISectionV2;